export default __webpack_public_path__ + "static/media/hu.b0b570c6.svg";